const {LitElement } = window.globalLit;

export default class BaseStepElement extends LitElement {
    static properties = {
        value: { type: Object },
        readonly: { type: Boolean },
    };

    constructor() {
        super();
        this.readonly = false;
    }

    createRenderRoot() { return this; }

    connectedCallback() {
        super.connectedCallback();
    }

    _onChange(field, event) {
        this.value = Object.assign({}, this.value, {
            [field]: event.detail || event.target.value
        });

        this.dispatchEvent(new CustomEvent('stepchange', {
            detail: this.value,
            bubbles: true,
        }));
    }

};
